export default __webpack_public_path__ + "static/media/voha-6.1e7797dc.png";